// @flow
import * as React from 'react';
import { Icon } from '@ta/styleguide.icon';
import styles from './MentionsAttribution.less';

type Props = {|
  icon: string,
  label: React.Node,
|};

const MentionsAttribution = ({ label, icon }: Props) => (
  <>
    <Icon name={icon} className={styles.icon} />
    {label}
  </>
);

export default MentionsAttribution;
